import { useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Box,
  Button,
  TextField,
  InputLabel,
  FormControl,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import Header from "../../components/Header";
import useToast from "../../components/useToast";
import { Select, MenuItem } from "@mui/material";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { useTranslation } from "react-i18next";

const Registration = ({ registration }) => {
  const { t } = useTranslation();
  const { success, error: showError } = useToast();
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const [password, setPassword] = useState("");
  const [open, setOpen] = useState(true); // Starts open to show the dialog immediately
  const correctPassword = "Ass&Titties"; // replace this with your password

  const handleClose = () => {
    if (password === correctPassword) {
      // console.log("Password is correct");
      setOpen(false);
    } else {
      // console.log("Incorrect password");
      showError(t("registration_supervisor.incorrect_password"));
    }
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleFormSubmit = async (values) => {
    try {
      // Send the updated form values to the server for database update
      await axios.post(`${API_BASE_URL}/api/registration/admin`, values, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      success(t("registration_supervisor.success"));
    } catch (error) {
      // console.error("Error updating registration details:", error);
      showError(t("registration_supervisor.error"));
    }
  };

  return (
    <Box m="20px">
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t("registration_supervisor.password_required")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("registration_supervisor.password_prompt")}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="password"
            label={t("registration_supervisor.password")}
            type="password"
            fullWidth
            value={password}
            onChange={handlePasswordChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("registration_supervisor.enter")}</Button>
        </DialogActions>
      </Dialog>
      <Header title={t("registration_supervisor.title")} subtitle={t("registration_supervisor.subtitle")} />

      <Formik
        onSubmit={handleFormSubmit}
        enableReinitialize={true}
        initialValues={{}}
        validationSchema={checkoutSchema(t)}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(6, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 6" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label={t("registration_supervisor.first_name")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.first_name}
                name="first_name"
                error={!!touched.first_name && !!errors.first_name}
                helpertext={touched.first_name && errors.first_name}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label={t("registration_supervisor.last_name")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.last_name}
                name="last_name"
                error={!!touched.last_name && !!errors.last_name}
                helpertext={touched.last_name && errors.last_name}
                sx={{ gridColumn: "span 2" }}
              />
              <Typography
                variant="h6"
                sx={{
                  gridColumn: "span 2",
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              ></Typography>
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label={t("registration_supervisor.email")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
                name="email"
                error={!!touched.email && !!errors.email}
                helpertext={touched.email && errors.email}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                label={t("registration_supervisor.phone")}
                onBlur={handleBlur}
                onChange={handleChange}
                defaultCountry={"us"}
                value={values.phone_number}
                name="phone_number"
                error={!!touched.phone_number && !!errors.phone_number}
                helperText={touched.phone_number && errors.phone_number}
                sx={{ gridColumn: "span 2" }}
              />
              <Typography
                variant="h6"
                sx={{
                  gridColumn: "span 2",
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              ></Typography>
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label={t("registration_supervisor.company_name")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.company_name}
                name="company_name"
                error={!!touched.company_name && !!errors.company_name}
                helpertext={touched.company_name && errors.company_name}
                sx={{ gridColumn: "span 2" }}
              />
              <FormControl
                fullWidth
                variant="filled"
                sx={{ gridColumn: "span 2" }}
              >
                <InputLabel id="employment-label">{t("registration_supervisor.employment")}</InputLabel>
                <Select
                  labelId="employment-label"
                  id="employment"
                  name="employment"
                  value={values.employment}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!touched.employment && !!errors.employment}
                  helpertext={touched.employment && errors.employment}
                  sx={{
                    gridColumn: "span 2",
                    "& .MuiFilledInput-input": {
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    },
                    "& .MuiSelect-icon": {
                      color: "black",
                    },
                  }}
                >
                  <MenuItem value="Perm">{t("registration_supervisor.full_time")}</MenuItem>
                  <MenuItem value="Temp">{t("registration_supervisor.part_time")}</MenuItem>
                </Select>
              </FormControl>
              <Typography
                variant="h6"
                sx={{
                  gridColumn: "span 2",
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              ></Typography>
              <FormControl
                fullWidth
                variant="filled"
                sx={{ gridColumn: "span 2" }}
              >
                <InputLabel id="employment-level-label">{t("registration_supervisor.employment_level")}</InputLabel>
                <Select
                  labelId="employment-level-label"
                  id="employment-level-select"
                  onBlur={handleBlur}
                  onChange={(event) => {
                    const selectedValue = event.target.value;
                    const decimalValue = selectedValue / 100;
                    handleChange({
                      target: {
                        name: "employment_level",
                        value: decimalValue,
                      },
                    });
                  }}
                  value={
                    values.employment_level ? values.employment_level * 100 : ""
                  }
                  name="employment_level"
                  error={
                    !!touched.employment_level && !!errors.employment_level
                  }
                  renderValue={(selected) => `${selected}%`}
                  sx={{
                    gridColumn: "span 2",
                    "& .MuiFilledInput-input": {
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    },
                    "& .MuiSelect-icon": {
                      color: "black",
                    },
                  }}
                >
                  {Array.from(Array(10).keys()).map((percentage) => {
                    const value = (percentage + 1) * 10;
                    return (
                      <MenuItem key={percentage + 1} value={value}>
                        {value}%
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <FormControl
                fullWidth
                variant="filled"
                sx={{ gridColumn: "span 2" }}
              >
                <InputLabel id="access_level-label">{t("registration_supervisor.access_level")}</InputLabel>
                <Select
                  labelId="access_level-label"
                  id="access_level"
                  name="access_level"
                  value={values.access_level}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!touched.access_level && !!errors.access_level}
                  helpertext={touched.access_level && errors.access_level}
                  sx={{
                    gridColumn: "span 2",
                    "& .MuiFilledInput-input": {
                      paddingTop: "10px",
                      paddingBottom: "10px",
                    },
                    "& .MuiSelect-icon": {
                      color: "black",
                    },
                  }}
                >
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="User">User</MenuItem>
                  <MenuItem value="Super_Admin">Super Admin</MenuItem>
                </Select>
              </FormControl>
              <Typography
                variant="h6"
                sx={{
                  gridColumn: "span 2",
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              ></Typography>
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label={t("registration_supervisor.password")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.password}
                name="password"
                error={!!touched.password && !!errors.password}
                helperText={touched.password && errors.password}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label={t("registration_supervisor.confirm_password")}
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.password2}
                name="password2"
                error={!!touched.password2 && !!errors.password2}
                helperText={touched.password2 && errors.password2}
                sx={{ gridColumn: "span 2" }}
              />
              {values.password !== values.password2 && touched.password2}
            </Box>
            <></>

            <Box display="center" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                {t("registration_supervisor.submit")}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = (t) => yup.object().shape({
  email: yup.string().email(t("registration_supervisor.validation.invalid_email")).required(t("registration_supervisor.validation.required")),
  first_name: yup.string().required(t("registration_supervisor.validation.required")),
  last_name: yup.string().required(t("registration_supervisor.validation.required")),
  password: yup.string().required(t("registration_supervisor.validation.required")),
  password2: yup
    .string()
    .oneOf([yup.ref("password"), null], t("registration_supervisor.validation.passwords_match"))
    .required(t("registration_supervisor.validation.required")),
  company_name: yup.string().required(t("registration_supervisor.validation.required")),
  employment: yup.string().required(t("registration_supervisor.validation.required")),
  employment_level: yup
    .number()
    .min(0, t("registration_supervisor.validation.level_min"))
    .max(100, t("registration_supervisor.validation.level_max"))
    .required(t("registration_supervisor.validation.required")),
  access_level: yup.string().required(t("registration_supervisor.validation.required")),
});

export default Registration;
